import { updateCurrentUser } from 'firebase/auth';
import {useAuth} from "../Contexts/AuthContexts"
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import CallService from '../Services/CallService';
import Topbar from '../Components/Topbar'
import MapboxAutocomplete from "react-mapbox-autocomplete";
import {CALL_API_URL} from '../Services/CallService'
import {useData} from '../Contexts/DataContext'


function EditEvent() {
    const [error, setError] = React.useState("")
    const [event, setEvent] = React.useState([])
    const navigate = useNavigate();
    const collector = useData();
    const eventsPage = () => {
        navigate("/UserHome")
    }
    const {eventID} = useParams();

    useEffect(() => {
        collector.data.forEach(event => {
          if (event.eventID == eventID) {
            setEvent(event); //set current event
          }
        });
    });

    const [eventData, setEventData] = React.useState(
        {
          eventName: event.eventName,
          host: event.host,
          description: event.description,
          floorNum: event.floorNum,
          location: event.location,
          time: event.time,
          date: event.date,
          capacity: event.capacity,
          inviteOnly: event.inviteOnly,
          latitude: event.latitude,
          longitude: event.longitude,
          attendees: event.attendees
        } )
        useEffect(() => {
          setEventData({
            eventName: event.eventName,
            host: event.host,
            description: event.description,
            floorNum: event.floorNum,
            location: event.location,
            time: event.time,
            date: event.date,
            capacity: event.capacity,
            inviteOnly: event.inviteOnly,
            latitude: event.latitude,
            longitude: event.longitude,
            attendees: event.attendees
        })
        }, [event.eventName])
    
       async function handleSubmit() {
          const response = await fetch(`${CALL_API_URL}/api/events/${eventID}`, { //re-create event with new fields (same eventID)
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(eventData)
          })
          alert("Event edited successfully!")
          await collector.refresh();
          eventsPage();
          return response.json();
      }

    function handleChange(event) {
        const {name, value, type, checked} = event.target
        setEventData(prevEventData => {
            return {
                ...prevEventData,
                [name]: type === "checkbox" ? checked : value
            }
        })
      }

      function _suggestionSelect(result, lat, long, text) {
        setEventData(prevEventData => {
          return {
              ...prevEventData,
              latitude: lat,
              longitude: long,
              location: text
          }
        })
      }


      return (
      <>
      <div className="bg-[#F7F8FC] w-[100%] overflow-y-scroll rounded-xl">
      <Topbar />
      <div className="bg-white px-[3%] mx-[8%] py-[1%] mb-[5%] mt-[2%]">
        <div className="mt-[15px] pt-[10px] pb-[25px] mx-[1%]">
            <p className="text-black text-[28px] font-semibold ml-[0%] pb-[0px]">Edit Event <span className="font-light">{event.eventName}</span></p>
            <form className="text-black text-[18px] font-lg ml-[0%] pb-[15px]">
                <h1 className="boxHeader italic pb-[15px]">Edit the fields below</h1>
                <p>{error}</p>
                <input className="bg-white drop-shadow-sm h-10 mb-5 py-1 pl-4 pr-16 w-full"
                        type="text"
                        placeholder="Event Name"
                        onChange={handleChange}
                        name="eventName"
                        value={eventData.eventName}
                />
                {eventData.location != undefined && eventData.location != "" && <MapboxAutocomplete
                    publicKey='pk.eyJ1IjoibXNhaG9vIiwiYSI6ImNsYXR4MXpqczAwcmwzb21zYXBtdXVlOWYifQ.tWyFO5O42cSkS632B-Di-Q'
                    inputClass="bg-white drop-shadow-sm h-10 mb-5 py-1 pl-4 pr-16 w-full"
                    onSuggestionSelect={_suggestionSelect}
                    country="us"
                    resetSearch={false}
                    placeholder="Location Name"
                    query={eventData.location}
                />}
                <input className="bg-white drop-shadow-sm h-10 mb-5 py-1 pl-4 pr-16 w-full"
                        type="floorNum"
                        placeholder="Floor / Room Number"
                        onChange={handleChange}
                        name="floorNum"
                        value={eventData.floorNum}
                />
                <input className="bg-white drop-shadow-sm h-10 mb-5 py-1 pl-4 pr-16 w-full"
                        type="text"
                        placeholder="Date (MM/DD/YY)"
                        onChange={handleChange}
                        name="date"
                        value={eventData.date}
                />
                <input className="bg-white drop-shadow-sm h-10 mb-5 py-1 pl-4 pr-16 w-full"
                        type="text"
                        placeholder="Time (00:00AM or 00:00PM)"
                        onChange={handleChange}
                        name="time"
                        value={eventData.time}
                />
                <input className="bg-white drop-shadow-sm h-10 mb-5 py-1 pl-4 pr-16 w-full"
                        type="text"
                        placeholder="Description"
                        onChange={handleChange}
                        name="description"
                        value={eventData.description}
                />
                <input className="bg-white drop-shadow-sm h-10 mb-5 py-1 pl-4 pr-16 w-full"
                        type="text"
                        placeholder="Capacity"
                        onChange={handleChange}
                        name="capacity"
                        value={eventData.capacity}
                />
                <input className="bg-white drop-shadow-sm h-10 mb-5 py-1 pl-4 pr-16 w-full"
                        type="text"
                        placeholder="Invite Only (true/false)"
                        onChange={handleChange}
                        name="inviteOnly"
                        value={eventData.inviteOnly}
                />
            </form>
            <button className="w-[25%] rounded-sm p-2 bg-black text-white cursor-pointer mr-[5px]" onClick={handleSubmit} >Edit Event</button>
            <button 
              type="button"  
              className="w-[10%] p-1.5 rounded-sm border-2 border-black text-black cursor-pointer mr-[5px]"
              onClick={eventsPage}> Cancel
            </button>
        </div>
      </div>
      </div>
        </>
    );
}

export default EditEvent;